export default {
  getEnrollmentsRequest (state) {
    state.loading = true
    state.enrollments = []
  },
  getEnrollmentsSuccess (state, data) {
    state.loading = false
    state.enrollments = data
    state.ordering = data.ordering
  },
  getEnrollmentsFailure (state) {
    state.loading = false
    state.enrollments = []
  },
  getEnrollmentByIdRequest (state) {
    state.loading = true
    state.enrollment = {}
  },
  getEnrollmentByIdSuccess (state, data) {
    state.loading = false
    state.enrollment = data
  },
  getEnrollmentByIdFailure (state) {
    state.loading = false
    state.enrollment = {}
  },
  getStudentByStudentNoRequest (state) {
    state.loading = true
    state.enrollment = {}
  },
  getStudentByStudentNoSuccess (state, data) {
    state.loading = false
    state.enrollment = data
  },
  getStudentByStudentNoFailure (state) {
    state.loading = false
    state.enrollment = {}
  },
  getEnrollmentBySchoolYearRequest (state) {
    state.loading = true
    state.enrollments = []
  },
  getEnrollmentBySchoolYearSuccess (state, data) {
    state.loading = false
    state.enrollments = data
  },
  getEnrollmentBySchoolYearFailure (state) {
    state.loading = false
    state.enrollments = []
  },
  getEnrollmentsByStudentRequest (state) {
    state.loading = true
    state.enrollments = []
  },
  getEnrollmentsByStudentSuccess (state, data) {
    state.loading = false
    state.enrollments = data
  },
  getEnrollmentsByStudentFailure (state) {
    state.loading = false
    state.enrollments = []
  },
  createEnrollmentRequest (state) {
    state.loading = true
  },
  createEnrollmentSuccess (state) {
    state.loading = false
  },
  createEnrollmentFailure (state) {
    state.loading = false
  },
  updateEnrollmentRequest (state) {
    state.loading = true
  },
  updateEnrollmentSuccess (state, data) {
    state.loading = false
  },
  updateEnrollmentFailure (state) {
    state.loading = false
  }
}
